import { useComponent, useElement, useLocale } from "../../../hooks";
import { useCampaignList } from "./hooks";

export const CampaignList = () => {
  const { t } = useLocale();
  const Button = useElement("Button");
  const Link = useElement("Link");
  const Table = useComponent("Table");
  const TrashConfirmModal = useComponent("TrashConfirmModal");
  const {
    trackScrolling,
    checkedList,
    checkedAll,
    setisMultipleDelete,
    setshowTrashConfirm,
    tableContent,
    activeShownTotal,
    deleteChecked,
    trashCampaign,
    trashCancel,
    showTrashConfirm,
    isMultipleDelete,
  } = useCampaignList();

  return (
    <div id="content-box" className="content" onScroll={trackScrolling}>
      <h1 className="title flex">
        All Campaigns
        <Link
          className="btn btn-primary btn-small ml20"
          href="/admin/campaign/add"
        >
          {t("add")}
        </Link>
        {(checkedList.length !== 0 || checkedAll) && (
          <Button
            onClick={() => {
              setisMultipleDelete(true);
              setshowTrashConfirm(true);
            }}
            className="btn btn-outline btn-small"
          >
            {t("delete")}
          </Button>
        )}
      </h1>
      <Table data={tableContent} pageSize={activeShownTotal} />
      <TrashConfirmModal
        trashOkAction={() => {
          isMultipleDelete ? deleteChecked() : trashCampaign();
        }}
        trashCancelAction={trashCancel}
        showTrashConfirm={showTrashConfirm}
        isMultipleDelete={isMultipleDelete}
      />
    </div>
  );
};
